<!-- casino1 -->
<div class="lvc-thumb" *ngIf="events.casino1.includes(eventId)">
    <div class="row">
        <div class="col-md-2 col-4" (click)="confirmLogin(item)" *ngFor="let item of data?.event_types;trackBy:trackByIndex;">
            <img class="img-fluid" src="https://speedcdn.io/assets/casinogames-new-v1/{{item?.id}}.webp" alt="{{item?.name}}" title="{{item?.name}}">
            <!-- <span>({{item?.id}} - {{item?.name}})</span> -->
        </div>
    </div>
    <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>
</div>

<!-- i-casino -->
<div class="int-casino-content position-relative" *ngIf="events.iCasino.includes(eventId)">
    <div class="tab-container">
        <div class="market_section tabcasino">
            <div class="fancyTabs" *ngIf="data">
                <!-- <div *ngFor="let tabDt of data.tables;trackBy:trackByIndex;"> -->
                    <!-- old icasino -->
                    <!-- <tabset #parentTabs type="fill innertabs d-block" class="casino_tabs_ul" id="myInnerTab">
                        <tab id="goto-casino-{{i}}-link" [heading]="'1 To ' + tabDt.name" *ngFor="let tabDt of data.tables;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent(i)">
                            <div class="icasino_ul_tabs">
                                <tabset #childTabs type="fill innertabs d-block">
                                    <tab id="goto-casino-{{i}}{{j}}-link" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                                        <ng-template tabHeading>
                                            {{innerTabDt.name}}
                                        </ng-template>
                                        <div class="intcasino-sub-tab">
                                            <div class="row py-2 mx-0" *ngIf="tabId == j">
                                                <div class="col-md-2 col-4" (click)="confirmBox(item, tabDt.name)" *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                                                    <div class="casino-images-box position-relative">
                                                        <img class="img-fluid" [src]="item.url_thumb ? item.url_thumb : item.image_path" alt="{{item.name}}">
                                                        <a href="javascript:void(0)" class="btn casino-btn">Play Now</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </tab>
                                </tabset>        
                            </div>
                        </tab>
                    </tabset> -->

                <!-- </div> -->

                <!-- new icasino -->
                <tabset #parentTabs class="casino_tabs_ul">
                    <tab *ngFor="let tabDt of data;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent(i)">
                        <ng-template tabHeading>
                            <!-- {{tabDt?.name | uppercase}} -->
                            {{tabDt?.name.charAt(0).toUpperCase() + tabDt?.name.slice(1)}}
                            <!-- <img class="img-fluid" src="assets/img/icon/{{tabDt?.slug}}.png"> -->
                        </ng-template>
                        <div class="icasino_ul_tabs">
                            <tabset #childTabs>
                                <tab id="tab1" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                                    <ng-template tabHeading>
                                        <img class="img-fluid tab-image" src="http://speedcdn.io/assets/int_tab_icons/{{innerTabDt?.slug}}.png">
                                        <!-- {{innerTabDt?.name | uppercase}} -->
                                        {{innerTabDt?.name.charAt(0).toUpperCase() + innerTabDt?.name.slice(1)}}
                                    </ng-template>
                                    <div class="intcasino-sub-tab">
                                        <div class="row py-2 mx-0" *ngIf="tabId == j">
                                            <div class="col-md-2 col-4" (click)="confirmBox(item, tabDt.name)" *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                                                <div class="casino-images-box position-relative">
                                                    <img class="img-fluid" [lazyLoad]="item.url_thumb ? item.url_thumb : item.image_path" alt="{{item.name}}">
                                                    <a href="javascript:void(0)" class="btn casino-btn">Play Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </tab>
                            </tabset>
                        </div>
                    </tab>
                </tabset>

            </div>
        </div>
    </div>
    <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>
</div>


<!-- Int Casino -->
<div class="int-casino-content position-relative" *ngIf="events.intCasino.includes(eventId)">
    <div class="tab-container">
        <div class="market_section tabcasino">
            <div class="fancyTabs">
                <tabset #parentTabs class="casino_tabs_ul">
                    <tab id="goto-casino-{{i}}" *ngFor="let tabDt of data;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent(i)">
                        <ng-template tabHeading>
                            {{tabDt?.name}}
                            <!-- <img class="img-fluid" src="assets/img/icon/{{tabDt?.slug}}.png"> -->
                        </ng-template>
                        <div class="icasino_ul_tabs">
                            <tabset>
                                <tab id="tab1" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                                    <ng-template tabHeading>
                                        <img class="img-fluid" src="assets/images/intcasino/{{innerTabDt?.slug}}.png">
                                        {{innerTabDt.name}}
                                    </ng-template>
                                    <div class="intcasino-sub-tab">
                                        <div class="row py-2 mx-0" *ngIf="tabId == j">
                                            <div class="col-md-2 col-4" (click)="confirmBox(item, tabDt.name)" *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                                                <div class="casino-images-box position-relative">
                                                    <img class="img-fluid" [src]="item.url_thumb ? item.url_thumb : item.image_path" alt="{{item.name}}">
                                                    <a href="javascript:void(0)" class="btn casino-btn">Play Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </tab>
                            </tabset>
                        </div>
                    </tab>
                </tabset>
            </div>
        </div>
    </div>
    <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>
</div>
<!--/ Int Casino End -->